import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/aircraft-intro/bg.png'
import foregroundImage from '../assets/images/aircraft-intro/fg-1.png'
import menuBtn from '../assets/images/aircraft-intro/menu-btn.png';
import desc1Image from '../assets/images/aircraft-intro/desc-1.png';
import desc2Image from '../assets/images/aircraft-intro/desc-2.png';

import bodyDesc from '../assets/images/aircraft-intro/aircraft-body-desc.png';
import bodyPart from '../assets/images/aircraft-intro/aircraft-body-part.png';
import engineDesc from '../assets/images/aircraft-intro/aircraft-engine-desc.png';
import enginePart from '../assets/images/aircraft-intro/aircraft-engine-part.png';
import landingGearDesc from '../assets/images/aircraft-intro/aircraft-landing-gear-desc.png';
import landingGearPart from '../assets/images/aircraft-intro/aircraft-landing-gear-part.png';
import tailDesc from '../assets/images/aircraft-intro/aircraft-tail-desc.png';
import tailPart from '../assets/images/aircraft-intro/aircraft-tail-part.png';
import wingDesc from '../assets/images/aircraft-intro/aircraft-wing-desc.png';
import wingPart from '../assets/images/aircraft-intro/aircraft-wing-part.png';

const desc = [ bodyDesc, engineDesc, landingGearDesc, tailDesc, wingDesc ];
const parts = [ bodyPart, enginePart, landingGearPart, tailPart, wingPart ];

class AircraftIntro extends Component {

    backMenuSound = './sounds/back-menu.mp3';
    partSound = './sounds/part.mp3';

    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: -1,
            bodyOpacity: 0,
            engineOpacity: 0,
            landingGearOpacity: 0,
            tailOpacity: 0,
            wingOpacity: 0,
            descImage: null,
            clicked: false
        };
    }
    
    select(index) {
        this.playPartSound();
        this.setState({
            descImage: desc[index],
            bodyOpacity: index === 0 ? 1.0 : 0.0,
            engineOpacity: index === 1 ? 1.0 : 0.0,
            landingGearOpacity: index === 2 ? 1.0 : 0.0,
            tailOpacity: index === 3 ? 1.0 : 0.0,
            wingOpacity: index === 4 ? 1.0 : 0.0,
            clicked: true
        });
    }

    goToMenuPage() {
        this.playBackMenuSound();
        this.props.history.push({
            pathname: './menu',
            state: {}
        });
    };

    playBackMenuSound() {
        let btnAudio = new Audio(this.backMenuSound);
        btnAudio.play();
    }

    playPartSound() {
        let btnAudio = new Audio(this.partSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' src={foregroundImage} style={{ width: '100%', left: '0%', top: '0%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' src={this.state.descImage} style={{ width: '45%', left: '9%', top: '51.5%', position: 'absolute' }}/>
                {
                    this.state.clicked && <img alt='' src={desc2Image} style={{ width: '32.8%', left: '61%', top: '67%', position: 'absolute' }}/>
                }
                {
                    !this.state.clicked && <img alt='' src={desc1Image} style={{ width: '40.4%', left: '13%', top: '67%', position: 'absolute' }}/>
                }
                <img alt='' src={wingPart} style={{ width: '30.7%', position: 'absolute', right: '13.6%', top: '10%', opacity: `${ this.state.wingOpacity }` }} onClick={() => this.select(4)}/>
                <img alt='' src={bodyPart} style={{ width: '41.25%', position: 'absolute', right: '4%', top: '28.4%', opacity: `${ this.state.bodyOpacity }` }} onClick={() => this.select(0)}/>
                <img alt='' src={tailPart} style={{ width: '14.16%', position: 'absolute', right: '35%', top: '11.2%', opacity: `${ this.state.tailOpacity }` }} onClick={() => this.select(3)}/>
                <img alt='' src={enginePart} style={{ width: '15%', position: 'absolute', right: '11.8%', top: '26.4%', opacity: `${ this.state.engineOpacity }` }} onClick={() => this.select(1)}/>
                <img alt='' src={landingGearPart} style={{ width: '6.2%', position: 'absolute', right: '16%', top: '49.4%', opacity: `${ this.state.landingGearOpacity }` }} onClick={() => this.select(2)}/>
                <img className='press-btn' alt='' src={menuBtn} style={{ height: '10.3%', bottom: '3%', left: '83%', position: 'absolute', background: 'transparent' }} onClick={this.goToMenuPage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(AircraftIntro);
